export default "__VITE_ASSET__CUQDkOFI__"